export default {"src":"/_next/static/media/education.2485649e.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};